<template>
  <section class="corpusDetail-section" v-loading="loading">
    <header class="corpusDetail-section-header">
      <div class="top-warp">
        <div class="left">
          <img src="../images/icon-corpus-title.png" alt="">
          <el-tooltip effect="dark" :disabled="tipsDisabled" :content="corpusDetailInfo.name"
                      placement="top-start">
            <div class="corpus-name" @mouseover="mouseOverShowTips($event)">
              {{corpusDetailInfo.name?corpusDetailInfo.name:'--'}}
            </div>
          </el-tooltip>
          <el-tooltip v-if="corpusDetailInfo.langDesc" effect="dark" :disabled="tipsDisabled"
                      :content="$i18n.locale === 'zh' ? corpusDetailInfo.langDesc.replace('>',' — ') : getEnlang(corpusDetailInfo.sourceLang,corpusDetailInfo.targetLang)"
                      placement="top-start">
            <div class="corpus-langDesc" @mouseover="mouseOverShowTips($event)">
              {{$i18n.locale === 'zh' ? corpusDetailInfo.langDesc.replace('>',' - ') : getEnlang(corpusDetailInfo.sourceLang,corpusDetailInfo.targetLang)}}
            </div>
          </el-tooltip>
          <div class="corpus-domain" v-show="corpusDetailInfo.domainName">
            {{$i18n.locale === 'zh' ? corpusDetailInfo.domainName : getEnDomain(corpusDetailInfo.domainCode)}}
          </div>
        </div>
        <div class="right">
          <el-button size="small" class="right-btn editor" @click="editorBankVisible=true">
            <i class="btn-icon editor-btn"></i>
            <span>{{$t('common.edit')}}</span>
          </el-button>
          <el-button size="small" class="right-btn download" @click="downloadBankVisible=true">
            <i class="btn-icon download-btn"></i>
            <span>{{$t('common.download')}}</span>
          </el-button>
          <el-button size="small" class="right-btn delete" @click="deleteBankVisible=true">
            <i class="btn-icon delete-btn"></i>
            <span>{{$t('common.del')}}</span>
          </el-button>
        </div>
      </div>
      <div class="bottom-warp">
        <div class="top">
          <div class="top-item corpus-sentCount">
            <span
                  class="label">{{$t('memoryBankV2.sentenceNum')}}：</span>{{corpusDetailInfo.sentCount?corpusDetailInfo.sentCount:0}}
          </div>
          <div class="top-item corpus-create-time">
            <span
                  class="label">{{$t('memoryBankV2.createTime')}}：</span>{{corpusDetailInfo.createTime?corpusDetailInfo.createTime:'--'}}
          </div>
        </div>
        <div class="corpus-remark">
          <span
                class="label">{{$t('memoryBankV2.remark')}}：</span>{{corpusDetailInfo.remark?corpusDetailInfo.remark:'--'}}
        </div>
      </div>
    </header>
    <main class="corpusDetail-section-container">
      <div class="table-operation">
        <div class="left">
          <el-button :disabled="isAddStatus" size="small" class="left-btn import-btn"
                     @click="handleImport">
            {{$t('common.import')}}
          </el-button>
          <el-button :disabled="isAddStatus" size="small" class="left-btn addSent-btn"
                     @click="handleAddSent">
            {{$t('common.addASingleSentence')}}
          </el-button>
        </div>
        <div class="right">
          <el-input :disabled="isAddStatus" clearable size="small"
                    :placeholder="$t('memoryBankV2.findText')" v-model="filter.source_sent"
                    @clear="handleFilterTable" @keyup.enter.native="handleFilterTable">
          </el-input>
          <el-button :disabled="isAddStatus" class="search-btn" icon="el-icon-search" size="small"
                     type="primary" @click="handleFilterTable">
          </el-button>
        </div>
      </div>
      <el-table ref="corpusDetailTable" :data="tableData" border height="calc(100% - 3.28em)"
                header-cell-class-name="header-cell-class-name" cell-class-name="cell-class-name"
                style="width: 100%" :row-class-name="rowClassNameMethod">
        <el-table-column type="index" :index="indexMethod" :label="$t('termBankV2.number')"
                         width="60" align="center">
        </el-table-column>
        <el-table-column prop="sourceSent" :label="$t('termBankV2.originText')">
          <template slot-scope="{row,$index}">
            <el-input v-if="$index===0&&isAddStatus" v-model="row.sourceSent" resize="none"
                      @input="handleTextareaInput(row,0)" type="textarea"
                      :placeholder="$t('memoryBankV2.pleaseInputOriginalText')">
            </el-input>
            <div v-else class="sourceSent" :class="specialLangClassName('source')"
                 :contenteditable="isAddStatus?'false':'true'" @focus="handleFocus($event,0)"
                 @blur="handleBlur($event,row,0)" v-html="row.sourceSent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="targetSent" :label="$t('termBankV2.translateText')">
          <template slot-scope="{row,$index}">
            <el-input v-if="$index===0&&isAddStatus" v-model="row.targetSent" resize="none"
                      @input="handleTextareaInput(row,1)" type="textarea"
                      :placeholder="$t('memoryBankV2.pleaseInputTranslation')">
            </el-input>
            <div v-else class="targetSent" :class="specialLangClassName('target')"
                 :contenteditable="isAddStatus?'false':'true'" @focus="handleFocus($event,1)"
                 @blur="handleBlur($event,row,1)" v-html="row.targetSent">
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" width="120">
          <template slot-scope="{row,$index}">
            <div class="table-icon-warp">
              <template v-if="$index===0&&isAddStatus">
                <el-tooltip :content="$t('common.save')" effect="dark" placement="top-start">
                  <div class="table-icon-warp_item icon-save" @click="handleAddSentSave(row)"></div>
                </el-tooltip>
                <el-tooltip :content="$t('termBankV2.cancel')" effect="dark" placement="top-start">
                  <div class="table-icon-warp_item icon-cancel" @click="handleAddSentCancel(row)">
                  </div>
                </el-tooltip>
              </template>
              <template v-else>
                <el-tooltip :disabled="isAddStatus" :content="$t('common.del')" effect="dark"
                            placement="top-start">
                  <div :class="{'delete-disabled_icon':isAddStatus}"
                       class="table-icon-warp_item icon-delete" @click="handleDelete(row)"></div>
                </el-tooltip>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <footer class="corpusDetail-section-footer">
      <Pagination :total="paginationInfo.total" :page.sync="paginationInfo.page"
                  :limit.sync="paginationInfo.rows" :pagerCount="paginationInfo.pagerCount"
                  :layout="paginationInfo.layout" :disabled="paginationInfo.disabled"
                  @pagination="handlePagination" />
    </footer>
    <!-- 编辑 -->
    <editCorpus :dialogVisible="editorBankVisible" :bankType="routeType"
                :corpusDetailInfo="corpusDetailInfo" @handleClose="editorBankVisible=false"
                @handleConfirm="handleEditorBankConfirm">
    </editCorpus>
    <!-- 删除库弹窗 -->
    <delete-dialog :dialogVisible="deleteBankVisible" @handleClose="deleteBankVisible=false"
                   @handleConfirm="handleDeleteBankConfirm">
    </delete-dialog>
    <!-- 下载库 -->
    <download-corpus-dialog :bankType="routeType" :corpusDetailInfo="corpusDetailInfo"
                            :dialogVisible="downloadBankVisible"
                            @handleClose="downloadBankVisible=false">
    </download-corpus-dialog>
    <!-- 删除句子弹窗 -->
    <delete-dialog :dialogVisible="deleteVisible" @handleClose="handleDeleteClose"
                   @handleConfirm="handleDeleteConfirm">
    </delete-dialog>
    <!-- 上传 -->
    <corpus-detail-upload-dialog :corpusDetailInfo="corpusDetailInfo" :bankType="routeType"
                                 :accept="accept" :dialogVisible="importVisible"
                                 @handleClose="handleImportClose"
                                 @handleConfirm="handleImportConfirm">
    </corpus-detail-upload-dialog>
  </section>
</template>
<script>
import DeleteDialog from '../components/deleteDialog.vue';
import CorpusDetailUploadDialog from '../components/corpusDetailUploadDialog.vue';
import DownloadCorpusDialog from '../components/downloadCorpusDialog.vue';
import EditCorpus from '../components/editCorpus.vue';
import { removeProperty, loopGetCorpusSentCount } from '@/utils';
import {
  getMemoryDetail,
  getTermDetail,
  queryPage,
  queryPageTermSent,
  addSent,
  addTermSent,
  batchDeleteByIdList,
  batchDeleteByTermSentIdList,
  delMemory,
  updateMemoryBank,
  updateTermBank,
  querySentCount,
} from '@/services/memoryBank';
import { delTerm, termQuerySentCount } from '@/services/term';
import ExceedTips from '../../../mixins/ExceedTips';
export default {
  name: "corpusDetail",
  mixins: [ExceedTips],
  components: {
    DeleteDialog,
    CorpusDetailUploadDialog,
    DownloadCorpusDialog,
    EditCorpus
  },
  data() {
    return {
      loading: true,
      // 全局setting.js 变量 特殊语种
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      // 路由携带参数
      routeQueryInfo: {},
      // 语料库详情
      corpusDetailInfo: {},
      // 分页器参数
      paginationInfo: {
        total: 0,
        page: 1,
        rows: 10,
        pagerCount: 5,
        layout: 'prev, pager, next,sizes',
        disabled: false
      },
      editorBankVisible: false,
      // 控制删除库弹窗
      deleteBankVisible: false,
      // 控制下载库弹窗
      downloadBankVisible: false,
      // 表格筛选条件
      filter: {
        source_sent: '',
        trans_lib_id: null,
        company_code: localStorage.myCompanyCode,
        platformType: this.$platformType,
      },
      // 表格数据
      tableData: [],
      // 聚焦时获取的句子
      beforeText: '',
      // 控制导入弹窗
      importVisible: false,
      // 是否处于添加单句状态
      isAddStatus: false,
      // 表格处于添加单句状态时，将表格最后一行删除后存储
      lastTableRow: {},
      // 控制删除句子弹窗
      deleteVisible: false,
      // 删除句子的id集合
      deleteIdList: [],
    }
  },
  computed: {
    /**
     * @desc 路由匹配
     * @result {String} term|memory|''
     */
    routeType() {
      const reg = /term|memory/
      let routeName = reg.exec(this.$route.name) ? reg.exec(this.$route.name)[0] : ''
      return routeName
    },

    // 导入限制类型
    accept() {
      if (this.routeType === 'memory') {
        return '.zip, .xlsx, .txt, .tmx'
      } else {
        return '.zip, .xlsx, .txt, .tbx'
      }
    },
  },
  watch: {
    'paginationInfo.page': {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.corpusDetailTable.bodyWrapper.scrollTop = 0
          })
        }
      }
    }
  },
  created() {
    const routeQueryData = JSON.parse(this.$Base64.decode(this.$route.query.key))
    this.routeQueryInfo = routeQueryData.row || {}
    if (Object.keys(this.$route.params).length) {
      const routeParamsData = JSON.parse(this.$Base64.decode(this.$route.params.key))
      this.filter.source_sent = routeParamsData.source_sent
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getCorpusDetail()
      this.getTableData()
    })
  },
  methods: {

    handleTextareaInput(row, type) {
      if (type) {
        row.targetSent = row.targetSent.replace(/^\s*/g, '');
      } else {
        row.sourceSent = row.sourceSent.replace(/^\s*/g, '');
      }
    },

    // 获取语料库详情
    async getCorpusDetail() {
      const params = {
        id: this.routeQueryInfo.id
      }
      const ajax = this.routeType === 'memory' ? getMemoryDetail : getTermDetail
      const { success, result } = await ajax(params)
      if (!success) return
      this.corpusDetailInfo = result
    },

    // 确认编辑库
    handleEditorBankConfirm(data) {
      this.editorBankVisible = false
      data && this.getCorpusDetail()
    },

    // 确认删除库
    async handleDeleteBankConfirm() {
      const params = {
        idList: [this.routeQueryInfo.id]
      }
      const ajax = this.routeType === 'memory' ? delMemory : delTerm
      const { success } = await ajax(params)
      if (!success) return
      this.$message.closeAll();
      this.$message.success(this.$t('termBankV2.deleteSuccess'))
      const name = this.routeType === 'memory' ? 'memoryBank' : 'termBank'
      window.setTimeout(this.$router.push({ name }), 1500)
    },

    // 列表内容显示
    specialLangClassName(source) {
      const { sourceLang, targetLang } = this.routeQueryInfo
      if (source === 'source') {
        return this.SPECIAL_LANGUAGE.indexOf(sourceLang) !== -1 ? 'right-view' : ''
      } else if (source === 'target') {
        return this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1 ? 'right-view' : ''
      }
    },

    // 表格序号
    indexMethod(index) {
      let i = index + 1
      return i < 10 ? `0${i}` : i;
    },

    /**
     * @desc 获取表格数据 
     */
    async getTableData() {
      this.filter.trans_lib_id = this.routeQueryInfo.id
      const params = {
        filter: removeProperty({ ...this.filter }),
        page: this.paginationInfo.page,
        rows: this.paginationInfo.rows,
        sort: {
          id: "desc"
        }
      }
      const ajax = this.routeType === 'memory' ? queryPage : queryPageTermSent
      const { list, totalRows, success } = await ajax(params)
      if (!success) return
      this.loading = false
      this.tableData = list
      this.paginationInfo.total = totalRows
      if (!list.length && this.paginationInfo.page > 1) {
        this.paginationInfo.page -= 1
        this.getTableData()
      }
    },

    // 表格数据筛选
    handleFilterTable() {
      this.paginationInfo.page = 1
      this.getTableData()
    },

    handleFocus(e, type) {
      this.beforeText = e.target.innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "")
    },
    async handleBlur(e, row, type) {
      const { target } = e
      const updateText = e.target.innerText.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
      if (updateText === '') {
        this.$message.closeAll()
        this.$message.error(this.$t('memoryBankV2.updateContent'))
        // 光标定位选中
        this.keepLastIndex(target)
        // target.innerText = this.beforeText
        return
      }
      if (updateText === this.beforeText) return
      const params = {
        id: row.id,
        [type ? 'targetSent' : 'sourceSent']: updateText,
        transLibId: this.corpusDetailInfo.id
      }
      const ajax = this.routeType === 'memory' ? updateMemoryBank : updateTermBank
      const { success } = await ajax(params)
      if (success) {
        this.$message.closeAll()
        this.$message.success(this.$t("memoryBankV2.editSuccess"))
        this.getTableData()
      } else {
        e.target.innerText = this.beforeText;
      }
    },
    // 光标定位方法
    keepLastIndex(dom) {
      if (window.getSelection) {
        dom.focus();
        const range = window.getSelection();
        range.selectAllChildren(dom);
        range.collapseToEnd();
      } else if (document.selection) {
        const range = document.selection.createRange();
        range.moveToElementText(dom);
        range.collapse(false);
        range.select();
      }
    },

    /**
     * @desc // 分页器数量或页面改变方法
     * @param {Object} data {page,limit}
     */
    handlePagination({ page, limit }) {
      this.getTableData()
    },

    // 点击导入
    handleImport() {
      this.importVisible = true
    },
    // 取消导入
    handleImportClose() {
      this.importVisible = false
    },
    // 确认导入
    async handleImportConfirm() {
      this.importVisible = false
      this.loading = true
      const ajax = this.routeType === 'memory' ? querySentCount : termQuerySentCount
      const res = await loopGetCorpusSentCount(ajax, { idList: [this.corpusDetailInfo.id] })
      if (res[0].status === 1) {
        this.paginationInfo.page = 1
        let timer = window.setTimeout(() => {
          this.getTableData()
          this.getCorpusDetail()
        }, 1000)
      }
    },

    // 表格添加单句样式
    rowClassNameMethod({ row, rowIndex }) {
      if (rowIndex === 0 && this.isAddStatus) {
        return 'add-sent-first-row'
      }
    },
    // 点击添加单句
    handleAddSent() {
      this.isAddStatus = true
      this.paginationInfo.disabled = true
      if (this.tableData.length === this.paginationInfo.rows) {
        this.lastTableRow = this.tableData.splice(this.tableData.length - 1, 1)[0]
      }
      this.tableData.unshift({
        sourceSent: '',
        targetSent: ''
      })
    },
    // 取消添加单句
    handleAddSentCancel() {
      if (this.isAddStatus) {
        this.isAddStatus = false
        this.paginationInfo.disabled = false
        this.tableData.shift()
        if (Object.keys(this.lastTableRow).length) {
          this.tableData.push(this.lastTableRow)
          this.lastTableRow = {}
        }
      }
    },
    // 确认添加单句
    async handleAddSentSave({ sourceSent, targetSent }) {
      if (!sourceSent || !targetSent) {
        this.$message.closeAll()
        this.$message.warning(this.$t('warehousingAudit.cannotEmpty'))
        return
      }
      const params = {
        sourceSent,
        targetSent,
        transLibId: this.routeQueryInfo.id
      }
      const ajax = this.routeType === 'memory' ? addSent : addTermSent
      const { success } = await ajax(params)
      if (!success) return
      this.$message.closeAll()
      this.$message.success(this.$t('common.added'))
      this.isAddStatus = false
      this.paginationInfo.disabled = false
      this.lastTableRow = {}
      this.paginationInfo.page = 1
      this.getTableData()
      this.getCorpusDetail()
    },

    // 点击删除按钮
    handleDelete({ id }) {
      if (this.isAddStatus) return
      this.deleteVisible = true
      this.deleteIdList.push(id)
    },
    // 表格取消删除
    handleDeleteClose() {
      this.deleteVisible = false
      this.deleteIdList = []
    },
    // 表格确认删除
    async handleDeleteConfirm() {
      const params = {
        idList: this.deleteIdList
      }
      const ajax = this.routeType === 'memory' ? batchDeleteByIdList : batchDeleteByTermSentIdList
      const { success } = await ajax(params)
      if (!success) return
      this.deleteIdList = []
      this.$message.closeAll();
      this.$message.success(this.$t('termBankV2.deleteSuccess'))
      this.getTableData()
      this.getCorpusDetail()
      this.deleteVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
@import "./style/index.less";
</style>